import React, { createContext } from 'react';

const EditorContext = createContext();
export default EditorContext;
